/** India Standard Time — UTC+05:30 */
export const IST_TIMEZONE = "Asia/Kolkata";

const IST_LOCALE = "en-IN";

export function toIstDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

export function formatIstDateTime(value, extra = {}) {
  const date = toIstDate(value);
  if (!date) return "";
  return date.toLocaleString(IST_LOCALE, {
    timeZone: IST_TIMEZONE,
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    ...extra,
  });
}

export function formatIstDate(value) {
  const date = toIstDate(value);
  if (!date) return "";
  return date.toLocaleDateString(IST_LOCALE, {
    timeZone: IST_TIMEZONE,
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function formatIstTime(value) {
  const date = toIstDate(value);
  if (!date) return "";
  return date.toLocaleTimeString(IST_LOCALE, {
    timeZone: IST_TIMEZONE,
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

/** YYYY-MM-DD in IST */
export function formatIstSqlDate(value) {
  const date = toIstDate(value) || new Date();
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: IST_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const get = (type) => parts.find((p) => p.type === type)?.value || "00";
  return `${get("year")}-${get("month")}-${get("day")}`;
}

/** MySQL DATETIME in IST, e.g. 2026-08-25 16:31:00 */
export function formatIstSqlDateTime(value) {
  const date = toIstDate(value) || new Date();
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: IST_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).formatToParts(date);
  const get = (type) => parts.find((p) => p.type === type)?.value || "00";
  return `${get("year")}-${get("month")}-${get("day")} ${get("hour")}:${get("minute")}:${get("second")}`;
}
